import "./withoutResults.sass";

/**
 * Se renderiza cuando no existen partidos
 *
**/
export default function WithoutResults({ componenteActual }) {
  return (
    <div className={`container-calendar-without-results component-${componenteActual}`}>
      <p className="calendar-without-results-text">No hay eventos con estos ajustes</p>
    </div>
  )
}